import { InfinityIcon } from "@images/svgIcons/infinityIcon"
import { OnOffIcon } from "@images/svgIcons/onOffIcon"
import { ProLargeIcon } from "@images/svgIcons/proLargeIcon"
import { BoxInfoResume } from "@modules/box/components/boxInfoResume"
import { BoxEntity } from "@modules/box/entities/boxEntity"
import { useBox } from "@modules/box/hooks/useBox"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { BoxesIcon } from "lucide-react"
import { useMemo } from "react"
import { Text } from "@/components/ui/baseUi/text"

type ProgramBoxSubscriberDetailsHeaderProps = {
  program: UserProgramDetailsEntity | ProgramBundleEntity
  subscriberDetails: ProgramSubscriberEntity & { box: BoxEntity }
  className?: string
} & React.ComponentProps<"div">

export function ProgramBoxSubscriberDetailsHeader({
  program,
  subscriberDetails,
  className,
  ...props
}: ProgramBoxSubscriberDetailsHeaderProps) {
  const { sidebarNavigateTo } = useSidebar()
  const { result: box } = useBox(subscriberDetails.box.id)

  const openUserProfile = () => {
    void sidebarNavigateTo({
      content: <BoxInfoResume boxId={subscriberDetails.box.id} />,
    })
  }

  const itemIcon = useMemo(() => {
    if (program instanceof ProgramBundleEntity) {
      return <BoxesIcon color="currentColor" width={15} height={15} className="shrink-0 text-neutral-500" />
    } else if (program.type === ProgramType.VIRTUAL) {
      return <InfinityIcon color="currentColor" width={15} height={15} className="shrink-0 text-neutral-500" />
    } else if (program.type === ProgramType.PRO) {
      return <ProLargeIcon color="currentColor" width={15} height={15} className="shrink-0 text-neutral-500" />
    } else return <OnOffIcon color="currentColor" width={15} height={15} className="shrink-0 text-neutral-500" />
  }, [program])

  return (
    <HuAvatarCardSidebar
      id={subscriberDetails.box.id}
      avatar={subscriberDetails.box.logo ?? undefined}
      firstname={subscriberDetails.box.name}
      lastname=""
      nationality={box?.address.country ?? undefined}
      onAvatarClick={openUserProfile}
      className={className}
      canUseContact={false}
      {...props}
      topContent={
        <div className="flex flex-col items-center pt-2">
          {!(program instanceof ProgramBundleEntity) && program.type === ProgramType.ONOFF ? (
            <Text fontStyle="TM">{word("program.label.athlete")}</Text>
          ) : (
            <Text fontStyle="TM">{word("program.label.mixed_subscribers")}</Text>
          )}

          <div className="flex max-w-[80%] items-center gap-2 text-textDefault-caption">
            <Text fontStyle="LM">{itemIcon}</Text>
            <Text fontStyle="LM" className="line-clamp-2 wrap-anywhere capitalize">
              {program.name}
            </Text>
          </div>
        </div>
      }
    />
  )
}
